import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../../../shared/material/app-material.module';
import { Router } from '@angular/router';
import { LoginService } from '../../../../core/services/login.service';
import { NotifierService } from '../../../../core/services/notifier.service';
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ReactiveFormsModule, AppMaterialModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  loginForm: FormGroup;
  isLoading = signal(false);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private notifier: NotifierService
  ) {
    this.loginForm = this.fb.group({
      userName: ['', [Validators.required, Validators.email]],
    });
  }

  goToUrl() {
    this.router.navigateByUrl('login');
  }

  get email() {
    return this.loginForm.get('email');
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const email = this.loginForm.value.userName;
      this.isLoading.set(true);

      this.loginService.sendPasswordResetEmail(email).subscribe(
        () => {
          this.notifier.showNotification({
            message: 'E-mail de recuperação enviado!',
            alternative: 'Verifique sua caixa de entrada.',
            messageType: 'successNotifier',
          });

          this.router.navigate(['/login']);
        },
        (error) => {
          this.notifier.showNotification({
            message: 'Falha ao enviar o e-mail.',
            alternative: 'Tente novamente mais tarde.',
            messageType: 'errorNotifier',
          });
          this.isLoading.set(false);
        }
      );
    }
  }
}
